module.exports = function(options) {
    return (APPLICATION !== 'author') ? options.fn(this) : options.inverse(this);
};
